import get from "lodash/get";
import { createSelector } from "reselect";

export const getMetricStreams = (_, props) => {
  return get(props, "streams", []);
};

export const getAverageStream = stream => {
  if (stream && stream.length > 0) {
    return stream.reduce((a, b) => a + (b.value || 0), 0) / stream.length;
  }
  return 0;
};

export const getSum = stream => {
  if (stream && stream.length > 0) {
    return stream.reduce((a, b) => {
      return a + b.value;
    }, 0);
  }
  return 0;
};

export const getFlatStreams = createSelector(
  [getMetricStreams],
  metricsStreams => {
    let flatMetrics = [];
    metricsStreams.forEach(metric => {
      metric.metric.forEach(stream => {
        flatMetrics.push(stream.stream);
      });
    });
    flatMetrics = flatMetrics.filter(x => x.length > 0);
    return flatMetrics;
  }
);

export const getAverageAllMetricsStreams = createSelector(
  [getFlatStreams],
  streams => {
    if (!streams || streams.length === 0) {
      return null;
    }
    const streamAverageList = streams.map(stream => {
      return getAverageStream(stream);
    });
    const average =
      streamAverageList.reduce((a, b) => {
        return a + b;
      }, 0) / streamAverageList.length;

    return average;
  }
);

export const getSumForLastStreamPoint = createSelector(
  [getFlatStreams],
  streams => {
    if (!streams || streams.length === 0) {
      return null;
    }

    const lastElementList = streams.map(stream => {
      if (stream && stream.length > 0) {
        const arrayForSort = [...stream];
        const sorted = arrayForSort.sort((a, b) => a.time - b.time);
        return sorted.reverse().find(point => point.value !== null);
      }
      return {};
    });

    let maxTimeValue = Math.max.apply(
      Math,
      lastElementList.map(function(o) {
        return o.time;
      })
    );

    const pointsForMaxTime = lastElementList.filter(
      x => x.time === maxTimeValue
    );

    const sum = getSum(pointsForMaxTime);

    return sum;
  }
);

export const getSumOfStreams = streams => {
  let streamsSum = [];

  streams.forEach(stream => {
    stream.forEach(dataPoint => {
      const existingDataTimestamp = streamsSum.find(
        s => s.time === dataPoint.time
      );
      if (existingDataTimestamp) {
        existingDataTimestamp.value += dataPoint.value;
      } else {
        streamsSum = [...streamsSum, { ...dataPoint }];
      }
    });
  });

  return streamsSum;
};
